module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('progress-bar'), _vm._v(" "), _c('monitor-map'), _vm._v(" "), _c('button', {
    staticStyle: {
      "position": "absolute",
      "top": "20px",
      "right": "30px"
    },
    on: {
      "click": _vm.test
    }
  }, [_vm._v("增加1000叶子节点")]), _vm._v(" "), _c('button', {
    staticStyle: {
      "position": "absolute",
      "top": "40px",
      "right": "30px"
    },
    on: {
      "click": _vm.test11
    }
  }, [_vm._v("每个组织机构增加1000叶子节点")]), _vm._v(" "), _c('button', {
    staticStyle: {
      "position": "absolute",
      "top": "70px",
      "right": "30px"
    },
    on: {
      "click": _vm.test12
    }
  }, [_vm._v("增加10个组织机构，每个组织机构有1000个点")])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab-vertical-left tab-vertical"
  }, [_c('div', {
    staticClass: "tab-title"
  }, [_c('div', {
    staticClass: "dropdown"
  }, [_c('a', {
    attrs: {
      "id": "dLabel",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_c('i')]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu list-group",
    attrs: {
      "id": "menuL",
      "aria-labelledby": "dLabel"
    }
  }, [_c('li', {
    staticClass: "list-group-item"
  }, [_vm._v("主面板")]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_vm._v("在线")]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_vm._v("离线")]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_vm._v("未定位")]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_vm._v("行驶中")]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_vm._v("停车中")]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_vm._v("停车超时")]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_vm._v("当日超速")]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_vm._v("紧急报警")]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_vm._v("紧急报警2")])])]), _vm._v(" "), _c('span', [_vm._v("主面板")]), _vm._v(" "), _c('em')]), _vm._v(" "), _c('div', {
    staticClass: "tab-header"
  }, [_c('div', {
    staticClass: "btn1",
    attrs: {
      "id": "btnUpL"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tabs"
  }, [_c('div', {
    staticClass: "innerTabs"
  }, [_c('div', {
    staticClass: "tab-item active"
  }, [_c('span', [_vm._v("主面板")])]), _vm._v(" "), _c('div', {
    staticClass: "tab-item"
  }, [_c('span', [_vm._v("在线")])]), _vm._v(" "), _c('div', {
    staticClass: "tab-item"
  }, [_c('span', [_vm._v("离线")])]), _vm._v(" "), _c('div', {
    staticClass: "tab-item"
  }, [_c('span', [_vm._v("未定位")])]), _vm._v(" "), _c('div', {
    staticClass: "tab-item"
  }, [_c('span', [_vm._v("行驶中")])]), _vm._v(" "), _c('div', {
    staticClass: "tab-item"
  }, [_c('span', [_vm._v("停车中")])]), _vm._v(" "), _c('div', {
    staticClass: "tab-item"
  }, [_c('span', [_vm._v("停车超时")])]), _vm._v(" "), _c('div', {
    staticClass: "tab-item"
  }, [_c('span', [_vm._v("当日超速")])]), _vm._v(" "), _c('div', {
    staticClass: "tab-item"
  }, [_c('span', [_vm._v("紧急报警")])]), _vm._v(" "), _c('div', {
    staticClass: "tab-item"
  }, [_c('span', [_vm._v("紧急报警2")])])])]), _vm._v(" "), _c('div', {
    staticClass: "btn2",
    attrs: {
      "id": "btnDownL"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "tab-body"
  }, [_c('div', {
    staticClass: "tab-content",
    attrs: {
      "id": "myWeek"
    }
  }, [_c('div', {
    staticClass: "tab-bar"
  }, [_c('div', {
    staticClass: "tab-row"
  }), _vm._v(" "), _c('div', {
    staticClass: "tab-row"
  }, [_vm._v("在线")]), _vm._v(" "), _c('div', {
    staticClass: "tab-row"
  }, [_vm._v("离线")]), _vm._v(" "), _c('div', {
    staticClass: "tab-row"
  }, [_vm._v("未定位")]), _vm._v(" "), _c('div', {
    staticClass: "tab-row"
  }, [_vm._v("行驶中")]), _vm._v(" "), _c('div', {
    staticClass: "tab-row"
  }, [_vm._v("停车中")]), _vm._v(" "), _c('div', {
    staticClass: "tab-row"
  }, [_vm._v("停车超时")]), _vm._v(" "), _c('div', {
    staticClass: "tab-row"
  }, [_vm._v("当日超速")]), _vm._v(" "), _c('div', {
    staticClass: "tab-row"
  }, [_vm._v("紧急报警")]), _vm._v(" "), _c('div', {
    staticClass: "tab-row"
  }, [_vm._v("紧急报警2")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-76effb7b","transformToRequire":{"audio":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/PageStatistic.vue
// module id = 1576
// module chunks = 0